// extracted by mini-css-extract-plugin
export default {"textContainer":"HomeDescriptionText_textContainer__56+Aw"};